export const clickable = {
    cursor: 'pointer',
    '&[disabled]': {
        pointerEvents: 'none'
    }
};
